module.exports = __webpack_public_path__ + "img/instrument-rating.290cc32a.png";